import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminSlider = () => {
  const [image, setImage] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = () => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/slider")
      .then(res => res.json())
      .then(res => setData(Array.isArray(res) ? res : []));
  };

  useEffect(fetchData, []);

  // ✅ SUBMIT
  const handleSubmit = async () => {
    if (!image) {
      alert("Please select image");
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(image);

    img.onload = async () => {
      // ✅ UPDATED SIZE HERE
      if (img.width !== 1600 || img.height !== 900) {
        alert("Image must be 1600x900 px ❌");
        return;
      }

      const formData = new FormData();
      formData.append("image", image);

      try {
        const res = await fetch("https://kasiaweb.ilakshyaerp.in/api/slider/add", {
          method: "POST",
          body: formData,
        });

        const data = await res.json();

        if (!res.ok) {
          alert(data.message);
          return;
        }

        alert(data.message || "Uploaded successfully ✅");

        setImage(null);
        fetchData();

      } catch (err) {
        alert("Server error ❌");
      }
    };
  };

  // ✅ DELETE
  const handleDelete = async (id) => {
    try {
      const res = await fetch(
        `https://kasiaweb.ilakshyaerp.in/api/slider/${id}`,
        { method: "DELETE" }
      );

      const data = await res.json();

      alert(data.message || "Deleted successfully");

      fetchData();
    } catch {
      alert("Delete failed ❌");
    }
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        <div className="notice-card">
          <h2>Add Slider</h2>

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) => setImage(e.target.files[0])}
          />

          {/* ✅ UPDATED NOTE */}
          <p style={{
            fontSize: "15px",
            color: "#e93e28",
            marginBottom: "10px"
          }}>
            ⚠ Recommended image size: <b>1600 × 900 px</b> <br />
            (Upload same size to avoid layout issues)
          </p>

          <button onClick={handleSubmit}>Upload</button>
        </div>

        <div className="notice-table">
          <table>
            <tbody>
              {data.map((d) => (
                <tr key={d.id}>
                  <td>
                    <img
                      src={`https://kasiaweb.ilakshyaerp.in/uploads/slider/${d.image}`}
                      width="100"
                      alt="slider"
                    />
                  </td>

                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(d.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminSlider;